import * as firebase from "firebase/app";
import "firebase/messaging";
const initializedFirebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyAgGNz1aho8puJMQJ1IebF_YV6vH_Q5IV0",
  authDomain: "ctgdispatch-bda39.firebaseapp.com",
  databaseURL: "https://ctgdispatch-bda39.firebaseio.com",
  projectId: "ctgdispatch-bda39",
  storageBucket: "ctgdispatch-bda39.appspot.com",
  messagingSenderId: "634861540991",
  appId: "1:634861540991:web:18ea52656316990303514a",
  measurementId: "G-79W8JHLFMB",
});
const supportedBrowser = firebase.messaging.isSupported();
const messaging = supportedBrowser ? initializedFirebaseApp.messaging() : null;

export { messaging };
